import history from "Router/history";

export const pushToHistory = (
  path: string,
  queryParams = new URLSearchParams(history.location.search),
): void => {
  history.push({
    pathname: path,
    search: queryParams.toString(),
  });
};
